import React from 'react';
import { render } from 'react-dom';
import App from './containers/App/AppBrand';

render(
  <App />,
  document.getElementById('root'),
);
